module.exports = __webpack_public_path__ + "static/media/pauGate.0f7329b0.jpg";